import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M50 13.75c-19.961 0-36.25 16.289-36.25 36.25S30.039 86.25 50 86.25 86.25 69.961 86.25 50 69.961 13.75 50 13.75m0 10c14.557 0 26.25 11.693 26.25 26.25S64.557 76.25 50 76.25 23.75 64.557 23.75 50 35.443 23.75 50 23.75" })
});
export default SvgCircle;
